<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      disable-pagination
      disable-sort
      hide-default-footer
      :headers="headers"
      :items="reserves"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Reservas Faturadas</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>

          <v-badge
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              class="ml-2"
              rounded
              outlined
              large
              color="primary"
              @click="dialogFilter = true"
            >
              <v-icon>{{ icons.mdiFilter }}</v-icon>
              Filtros
            </v-btn>
          </v-badge>

          <v-spacer></v-spacer>
          <span v-if="filter.checkin_date_start && filter.checkin_date_end">
            Periodo Checkin: de <b style="color:black">{{ formatDate(filter.checkin_date_start) }}</b>
            ate <b style="color:black">{{ formatDate(filter.checkin_date_end) }}</b>
          </span>
        </v-toolbar>
      </template>

      <template v-slot:item.guests="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >{{ firstGuest(item) }}</span>
          </template>
          <span>{{ allGuests(item) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.company_name="{ item }">
        {{ item.company ? item.company.fantasy_name : '-' }}
      </template>

      <template v-slot:item.check_in="{ item }">
        {{ formatDate(item.check_in) }}
      </template>

      <template v-slot:item.check_out="{ item }">
        {{ formatDate(item.check_out) }}
      </template>

      <template v-slot:item.billing_checkout_scope="{ item }">
        {{ billingScope(item.billing_checkout_scope) }}
      </template>

      <template v-slot:item.billing_status="{ item }">
        <v-chip
          small
          :color="billingStatusColor(item.billing_status)"
        >
          {{ billingStatusLabel(item.billing_status) }}
        </v-chip>
      </template>

      <template v-slot:item.billing_available="{ item }">
        {{ formatMoney(item.billing_available) }}
      </template>

      <template v-slot:foot>
        <tr style="height:44px; background:#fafafa">
          <td
            colspan="9"
            style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
          >
            TOTAL DE RESERVAS: <b>{{ reserves.length }}</b>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="filter.checkin_date_start"
                outlined
                type="date"
                label="Data Checkin Inicial"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="filter.checkin_date_end"
                outlined
                type="date"
                label="Data Checkin Final"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                v-model="filter.show_all"
                inset
                label="Mostrar todas as reservas faturadas"
                color="primary"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiFilter } from '@mdi/js'
import { mapActions } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import NoDataTable from '@/components/NoDataTable.vue'

export default {
  components: {
    NoDataTable,
    BarTitleDialog,
  },
  data: () => ({
    loadingTable: false,
    dialogFilter: false,
    reserves: [],
    filter: {
      show_all: false,
    },
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'EMPRESA',
        value: 'company_name',
      },
      {
        text: 'HOSPEDE',
        value: 'guests',
      },
      {
        text: 'CHECKIN',
        value: 'check_in',
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
      },
      {
        text: 'ESCOPO',
        value: 'billing_checkout_scope',
      },
      {
        text: 'STATUS FATURAMENTO',
        value: 'billing_status',
      },
      {
        text: 'SALDO DISPONIVEL',
        value: 'billing_available',
      },
      {
        text: 'MOTIVO',
        value: 'billing_reason',
      },
    ],
    icons: {
      mdiFilter,
    },
  }),
  computed: {
    bagFilter() {
      let count = 0
      if (this.filter.checkin_date_start) count += 1
      if (this.filter.checkin_date_end) count += 1
      if (this.filter.show_all) count += 1

      return count
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    ...mapActions('billed_reserves', ['getAll']),
    initialize() {
      this.loadingTable = true
      this.getAll(this.filter)
        .then(response => {
          this.reserves = response.data
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    confirmFilter() {
      this.initialize()
      this.dialogFilter = false
    },
    clearFilter() {
      this.filter = {
        show_all: false,
      }
    },
    billingScope(scope) {
      switch (scope) {
        case 'total':
          return 'Total'
        case 'accommodation':
          return 'Hospedagem'
        case 'consumption':
          return 'Consumo'
        default:
          return '-'
      }
    },
    billingStatusLabel(status) {
      switch (status) {
        case 'ok':
          return 'OK'
        case 'blocked':
          return 'Bloqueado'
        case 'disabled':
          return 'Desabilitado'
        case 'no_credit':
          return 'Sem saldo'
        default:
          return 'Erro'
      }
    },
    billingStatusColor(status) {
      switch (status) {
        case 'ok':
          return 'success'
        case 'blocked':
          return 'warning'
        case 'disabled':
          return 'secondary'
        case 'no_credit':
          return 'error'
        default:
          return 'error'
      }
    },
    firstGuest(item) {
      if (item.guest && item.guest.length > 0) {
        return item.guest[0].name
      }
      if (item.guest_unknown && item.guest_unknown.length > 0) {
        return item.guest_unknown[0].name
      }

      return '-'
    },
    allGuests(item) {
      const guests = []

      if (item.guest) {
        item.guest.forEach(guest => {
          guests.push(guest.name)
        })
      }

      if (item.guest_unknown) {
        item.guest_unknown.forEach(guest => {
          guests.push(guest.name)
        })
      }

      return guests.join(', ')
    },
    formatDate(date) {
      if (!date) {
        return ''
      }

      const result = new Date(date)

      return result.toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      })
    },
    formatMoney(value) {
      const parsed = parseFloat(value)
      if (Number.isNaN(parsed)) {
        return '0,00'
      }

      return parsed.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
</script>
